import { Trans } from '@lingui/macro';
import { Chip } from '@pocketlaw/tetris';
export function CurrentDocumentBadge() {
    return (<Chip size="small" appearance="secondary" label={<Trans comment="Label for current document in the File Browser">Current document</Trans>}/>);
}
